import './_refill-fields.scss';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Collapse } from 'react-bootstrap';

import FieldRefillSwitch from '../../Fields/RefillSwitch';
import FieldRefillType from '../../Fields/RefillType';
import FieldRefillCheck from '../../Fields/RefillCheck';
import FieldRefillRejection from '../../Fields/RefillRejection';
import FieldRefillCount from '../../Fields/RefillCount';
import FieldRefillMinimumQuantity from '../../Fields/RefillMinimumQuantity';
import FieldRefillDays from '../../Fields/RefillDays';
import FieldRefillMaximumQuantity from '../../Fields/RefillMaximumQuantity';
import ProviderField from '../ProviderFields';

import * as types from '../../reducer/constants';
import { getAccessCount, getAccessMinimalQuantity, getAccessProvider, getAccessRefillCheck } from './helper';

/* eslint-disable react/prop-types */
const FieldsRefill = (props) => {
  const { config } = useSelector((state) => state.services);
  const { form, errorProviderRefill, providerFormRefill, isLoadingProviderRefill, dispatchServiceData } = props;
  const {
    refill: { refill_provider_id, refill_provider_service_id, refill_provider_service_params },
  } = form;
  const refillType = form?.refill?.refill_type;

  const showRefillFields = refillType !== 0;
  const showMinimalQuantity = useMemo(() => getAccessMinimalQuantity(form.refill, config), [form.refill, config]);
  const showCount = useMemo(() => getAccessCount(form.refill, config), [form.refill, config]);
  const showProvider = useMemo(() => getAccessProvider(form.refill, config), [form.refill, config]);
  const showRefillCheck = useMemo(() => getAccessRefillCheck(config), [config]);

  const onChangeRefillProviderId = (value) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_PROVIDER_ID, value });
  };

  const onChangeRefillProviderServiceId = (value) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_PROVIDER_SERVICE_ID, value });
  };

  const onChangeRefillCustomField = (fieldKey, fieldValue) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_CUSTOM_FIELDS, key: fieldKey, value: fieldValue });
  };

  return (
    <>
      <FieldRefillSwitch {...props} />
      <Collapse in={showRefillFields}>
        <div>
          {showRefillFields ? (
            <div className="refill-fields">
              <FieldRefillType {...props} />
              {showRefillCheck ? (
                <>
                  <FieldRefillCheck {...props} />
                  <FieldRefillRejection {...props} />
                </>
              ) : null}
              {showProvider ? (
                <ProviderField
                  isLoading={isLoadingProviderRefill}
                  form={form}
                  providerForm={providerFormRefill}
                  error={errorProviderRefill}
                  customFieldsValues={refill_provider_service_params}
                  providerId={refill_provider_id}
                  providerServiceId={refill_provider_service_id}
                  onChangeProviderId={onChangeRefillProviderId}
                  onChangeProviderServiceId={onChangeRefillProviderServiceId}
                  onChangeCustomField={onChangeRefillCustomField}
                  refill
                />
              ) : null}
              {showCount ? <FieldRefillCount {...props} /> : null}
              {/* Minimal и Maximal работают по одной и той же логике отображения  */}
              {showMinimalQuantity ? <FieldRefillMinimumQuantity {...props} /> : null}
              {showMinimalQuantity ? <FieldRefillMaximumQuantity {...props} /> : null}
              <FieldRefillDays {...props} />
            </div>
          ) : null}
        </div>
      </Collapse>
    </>
  );
};

export default FieldsRefill;
